import {Project} from "../models/project";


export class ContractorFilter {

    /**
     * Apply contractor filters
     * @param projects
     * @param filters
     */
    static apply(projects: Project[], filters: string[]): Project[] {
        if (!filters || filters.length === 0) {
            return projects;
        }
        // check if process filters included
        if (!filters.some((f) => f.includes("contractor-"))) {
            // no contractor filters
            return projects;
        }

        return projects.filter((p: Project) => {
            const key = `contractor-${p.contractorId}`;
            // show project when filter key matches
            return filters.includes(key);
        });
    }
}
